import { createContext, useState } from "react";


export const DesignationContext = createContext()

export const DesignationProvider = ({children})=>{

    const [selectedValue, setSelectedValue] = useState(""); // State to store selected value
    const[filteredresults,setFilteredresults] = useState([])
    const[columnvalue,setcolumnvalue] = useState('')
    const [rowdata,setrowdata] = useState([])
    const [designation,setDesignation] = useState({
        value:"",
      
    })
    const handleClearSelection = () => {
      
      setSelectedValue("");         
      setcolumnvalue("");           
      setFilteredresults(rowdata);     
    }

    return(

             <DesignationContext.Provider value={{designation,setDesignation,selectedValue, setSelectedValue,
              filteredresults,setFilteredresults,columnvalue,setcolumnvalue,handleClearSelection,rowdata,setrowdata


             }}>

               {children}

             </DesignationContext.Provider>

    )




}